var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blacklist-wrapper",class:{'default': !_vm.hasBlacklist}},[(_vm.hasBlacklist)?_c('div',_vm._l((_vm.blacklist),function(item){return _c('blacklist-item',{key:item.userID,attrs:{"profile":item}})}),1):_c('span',{staticStyle:{"color":"gray"}},[_vm._v("黑名单还是空的")])])
}
var staticRenderFns = []

export { render, staticRenderFns }